import React, { useContext, useEffect } from "react";
import geojsonExtent from "@mapbox/geojson-extent";

import { MapContext } from "../Map";

export default function CountyBoundaryLayer({ countyGeoJsonUrl, fitBounds }) {
  const map = useContext(MapContext);

  useEffect(() => {
    if (!map) return;

    map.addSource("county", {
      type: "geojson",
      data: countyGeoJsonUrl,
    });

    const firstSymbolLayer = map.getStyle().layers.find((l) => l.type == "symbol");
    const beforeId = firstSymbolLayer && firstSymbolLayer.id;

    map.addLayer({
      id: "county-fill",
      type: "fill",
      source: "county",
      paint: {
        "fill-color": "#6b7280",
        "fill-opacity": 0.06,
      },
    }, beforeId);

    map.addLayer({
      id: "county-halo",
      type: "line",
      source: "county",
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#ffffff",
        "line-width": 5,
        "line-opacity": 0.8,
      },
    }, beforeId);

    map.addLayer({
      id: "county",
      type: "line",
      source: "county",
      layout: {
        "line-join": "round",
        "line-cap": "round",
      },
      paint: {
        "line-color": "#6b7280",
        "line-width": 2.5,
        "line-dasharray": [2, 1.5],
      },
    }, beforeId);

    if (fitBounds) {
      fetch(countyGeoJsonUrl)
        .then((response) => response.json())
        .then((geojson) => {
          map.fitBounds(geojsonExtent(geojson), { padding: 10, animate: false });
        });
    }
  }, [map]);

  return <></>;
}
